import { createAsyncThunk, createSlice, ActionReducerMapBuilder } from '@reduxjs/toolkit';
import axios from 'axios';
import store from 'src/services/redux/app/Store';

const VENDOR_MC_URL = `${process.env.REACT_APP_API_PIM_URL}`;

interface IState {
  data: any;
  tabCount: any;
  loading: boolean;
  done: boolean;
  showError: boolean;
  error: any;
  questionHistory: any;
  readyAnswers: any;
}

const initialState: IState = {
  data: [],
  tabCount: {},
  questionHistory: [],
  readyAnswers: [],
  loading: false,
  done: false,
  error: null,
  showError: false,
};

export const productQuestions = createAsyncThunk('productQuestions/list', async (data: any) => {
  const userId = store.getState()?.auth?.user?.vendor?.id;
  const res = await axios.get(`${VENDOR_MC_URL}/product-question/byvendor/${userId}?${data}`);
  return res.data;
});

export const productQuestionsTabCount = createAsyncThunk('productQuestions/tabs', async () => {
  const userId = store.getState()?.auth?.user?.vendor?.id;
  const res = await axios.get(`${VENDOR_MC_URL}/product-question/count/${userId}`);
  return res.data;
});
export const productQuestionsShowHistory = createAsyncThunk('productQuestions/show-history', async (questionId: string) => {
  const res = await axios.get(`${VENDOR_MC_URL}/product-question/show-history/${questionId}`);
  return res.data;
});
export const productQuestionsReadyAnswer = createAsyncThunk('product-answer-template', async () => {
  const userId = store.getState()?.auth?.user?.vendor?.id;
  const res = await axios.get(`${VENDOR_MC_URL}/product-answer-template/${userId}/list`);
  return res.data;
});
const productReviewsSlice = createSlice({
  name: 'productQuestions',
  initialState,
  reducers: {
    setError: (state, action) => {
      state.showError = action.payload;
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<IState>) => {
    builder.addCase(productQuestions.pending, (state, action) => {
      state.loading = true;
      state.done = false;
      state.data = [];
      state.error = null;
    });
    builder.addCase(productQuestions.fulfilled, (state, action) => {
      state.loading = false;
      state.done = true;
      if (action.payload.items.length > 0) {
        state.data = action.payload;
      } else {
        state.error = 'Hata! Veri listelenemedi';
        state.data = [];
      }
    });
    builder.addCase(productQuestions.rejected, (state, action) => {
      state.loading = false;
      state.showError = true;
      state.error = 'Hata! Veri listelenemedi.';
      state.data = [];
    });
    //
    builder.addCase(productQuestionsTabCount.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(productQuestionsTabCount.fulfilled, (state, action) => {
      state.loading = false;
      state.tabCount = action.payload;
      state.done = true;
    });
    builder.addCase(productQuestionsTabCount.rejected, (state, action) => {
      state.loading = false;
      state.showError = true;
      state.error = 'Hata! Veri listelenemedi.';
      state.tabCount = [];
    });
    //
    builder.addCase(productQuestionsShowHistory.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(productQuestionsShowHistory.fulfilled, (state, action) => {
      state.loading = false;
      state.questionHistory = action.payload;
      state.done = true;
    });
    builder.addCase(productQuestionsShowHistory.rejected, (state, action) => {
      state.loading = false;
      state.showError = true;
      state.error = 'Hata! Veri listelenemedi.';
      state.questionHistory = [];
    });
    //
    builder.addCase(productQuestionsReadyAnswer.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(productQuestionsReadyAnswer.fulfilled, (state, action) => {
      state.loading = false;
      state.readyAnswers = action.payload;
      state.done = true;
    });
    builder.addCase(productQuestionsReadyAnswer.rejected, (state, action) => {
      state.loading = false;
      state.showError = true;
      state.error = 'Hata! Veri listelenemedi.';
      state.readyAnswers = [];
    });
  },
});
export const { setError } = productReviewsSlice.actions;
export default productReviewsSlice.reducer;
